import { useData } from "@hooks/useData";
import { ID } from "@datassential/platform-ui-lib";
import { components } from "@apiSchema";
import http from "@core/fetch";
import apiConfig from "@apiConfig";

type CategoryKeywords = components['schemas']['LrCategorySocialKeywordViewModel'];
export type CategoryLensSocialKeyword = components['schemas']['LrCategorySocialKeyword'];

type Data = {
    items: Map<ID, CategoryLensSocialKeyword[]>;
};

const DEFAULT_DATA: Data = {
    items: new Map(),
};

const REQUEST_TYPE: keyof typeof apiConfig = 'get category lens all social';

async function getHomeCategoryLensAllSocial(): Promise<Data> {
    try {
        const response: CategoryKeywords[] = await http.get(REQUEST_TYPE);

        const items = new Map<ID, CategoryLensSocialKeyword[]>();

        (response ?? []).forEach(cat => {
            items.set((cat.categoryId ?? 0) as ID, cat.keywords ?? []);
        });

        return { items };
    } catch (err) {
        console.error('Fetch error:', REQUEST_TYPE, err);
        return DEFAULT_DATA;
    }
}

export function useHomeCategoryLensAllSocial() {
    return useData(DEFAULT_DATA, getHomeCategoryLensAllSocial);
}
